import axios from "axios";
import { API_SERVER, TIMEOUT_API_POST_IN_MILISECUNDES } from "config";
import { configAuthToken } from "./usersDataManager";

export const apiCredentials = axios.create({
  baseURL: API_SERVER,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: TIMEOUT_API_POST_IN_MILISECUNDES,
  withCredentials: true
});

export const apiTokenManager = (token) => axios.create({ 
  baseURL: API_SERVER,
  headers: { Authorization: configAuthToken(token) },
  timeout: TIMEOUT_API_POST_IN_MILISECUNDES
});

const apiManager = axios.create({
  baseURL: API_SERVER,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: TIMEOUT_API_POST_IN_MILISECUNDES,
});

export default apiManager;